import React, {useContext} from 'react';
import {errorSink} from '../ErrorSink';
import {PortalSelect, PortalSelectOption} from "../PortalSelect";
import {FormContext} from '../metadata/MDForm';

export function SelectScheduledItem({attr, ...props}) {
  const formContext = useContext(FormContext);
  const productScheduledItems = formContext.productSetupContext.productScheduledItem;

  if (!productScheduledItems) {
    return errorSink('There were no defined Product Scheduled Items for the attribute' + JSON.stringify(attr));
  }

  return <PortalSelect {...props}>
      {
        productScheduledItems.map(({classCd, shortDesc}, index) => <PortalSelectOption value={classCd} key={index}>
          {shortDesc}
        </PortalSelectOption>)
      }
    </PortalSelect>;
}

